module.exports = __webpack_public_path__ + "static/Logo_1-8f282ef3e7fe198d7d601303bf8a44a0.png";